import { render, staticRenderFns } from "./give-dialog.vue?vue&type=template&id=706140ca&"
import script from "./give-dialog.vue?vue&type=script&lang=js&"
export * from "./give-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports